import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from "@ionic/react";
import {Panel} from "primereact/panel";
import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import "./Menu.css";
import {AuthContext} from "../providers/authContext";
import {
  barChartOutline,
  bookOutline,
  calculatorOutline,
  cashOutline,
  eyeOutline,
  receiptOutline,
  walletOutline
} from "ionicons/icons";

const YoneticiMenuComponent: React.FC = () => {
  const {kurumBilgileri, authInfo} = React.useContext(AuthContext);

  const location = useLocation();
  const [aktifIndeks, setAktifIndeks] = useState(0);

  return (
    <IonMenu contentId="yonetici-main" type="overlay" swipeGesture={false}>
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>{authInfo?.user?.detail?.adSoyad}</IonListHeader>
          <IonNote>{kurumBilgileri?.kisaTanim}</IonNote>
          <Panel header="TAHSİLAT">
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/tahsilat-gozlem"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/tahsilat-gozlem"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={cashOutline}
                />
                <IonLabel>Tahsilat Gözlem</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/tahsilat-gozlem-grafik"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/tahsilat-gozlem-grafik"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={barChartOutline}
                />
                <IonLabel>Tahsilat Gözlem Grafik</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/kasa-durumu"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/kasa-durumu"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={walletOutline}
                />
                <IonLabel>Kasa Durumu</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/mukellef-borc-sorgulama"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/mukellef-borc-sorgulama"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={calculatorOutline}
                />
                <IonLabel>Mükellef Borç Sorgulama</IonLabel>
              </IonItem>
            </IonMenuToggle>
          </Panel>
          <Panel header="BÜTÇE / MUHASEBE">
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/banka-bakiye"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/banka-bakiye"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={bookOutline}
                />
                <IonLabel>Banka Bakiye</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/odeme-gozlem"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/odeme-gozlem"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={eyeOutline}
                />
                <IonLabel>Ödeme Gözlem</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/gelir-gozlem"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/gelir-gozlem"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={eyeOutline}
                />
                <IonLabel>Gelir Gözlem</IonLabel>
              </IonItem>
            </IonMenuToggle>
            <IonMenuToggle autoHide={false}>
              <IonItem
                className={
                  location.pathname === "/yonetici/cari-ekstre"
                    ? "selected"
                    : ""
                }
                routerLink="/yonetici/cari-ekstre"
                routerDirection="none"
                lines="none"
                detail={false}
              >
                <IonIcon
                  className="ion-no-margin ion-margin-end"
                  slot="start"
                  icon={receiptOutline}
                />
                <IonLabel>Cari Ekstre</IonLabel>
              </IonItem>
            </IonMenuToggle>
          </Panel>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default YoneticiMenuComponent;
